<div class="radios-container">
  <div class="header">
    <div class="label">{{ label }}</div>
  </div>

  <ul class="radios-list vertical">
    @for (option of options; track option.value; let index = $index) {
      <li>
        <label class="radio-label" [class.disabled]="option.disabled">
          <input
            type="radio"
            [tabIndex]="index"
            [name]="controlsName"
            [value]="option.value"
            [checked]="value === option.value"
            [disabled]="disabled || option.disabled"
            (change)="selectRadio(option, index)"
          >

          <span class="out-circle"></span>
          <span class="inner-circle"></span>

          <span class="radio-text-label">
            <span>{{ option.label }}</span>

            @if (option.value == SendOption.Sign) {
              @if (isLoading) {
                <span class="e-sign-source loading">
                  <i class="fad fa-spinner-third fa-spin"></i>
                </span>
              } @else {
              <span [class]="'e-sign-source ' + eSignSourceClass">
                <i class="source-icon"></i>
                <span>{{ eSignSourceName }}</span>
              </span>
              }
            }
          </span>
        </label>
      </li>
    }
  </ul>

  @if (displayValidationError) {
    <app-validation-error [customErrors]="customErrors"/>
  }
</div>
